<template>
  <div v-if="page === 'edit'">
    <StudyEdit :study="studyToEdit" @returnToSearch="returnToSearch" />
  </div>
  <div v-else>
    <StudySearch
      v-bind:form="form"
      @onSaveForm="onSaveForm"
      @onEditStudy="onEditStudy"
    />
  </div>
</template>

<script>
import StudyEdit from "../components/Studies/Edit.vue";
import StudySearch from "../components/Studies/Search.vue";

export default {
  name: "Studies",
  components: {
    StudyEdit,
    StudySearch,
  },
  created() {
    // Set fast link search
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    let action = params.get("action");

    if (action === "search") {
      let readValue = (name) => {
        if (params.get(name) !== null) {
          return params.get(name);
        } else {
          return "";
        }
      };

      let readArray = (name) => {
        if (params.get(name) !== null) {
          return params.get(name).split(',');
        } else {
          return [];
        }
      }

      this.form = {
        accessionNo: readValue("accessionNo"),
        patName: readValue("patName"),
        patId: readValue("patId"),
        studyDate: readValue("studyDates"),
        modsInStudy: readArray("modsInStudy"),
        studyId: readValue("studyId"),
        studyDesc: readValue("studyDesc"),
        instName: readValue("instName"),
        stationName: readValue("stationName"),
        refPhysician: readValue("refPhysician"),
        preset: readValue("preset"),
        archive: "LOCAL",
      };
    }
  },
  data: () => ({
    form: null,
    page: "search",
    studyToEdit: null,
  }),
  methods: {
    onSaveForm(form) {
      this.form = form;
    },
    onEditStudy(sel) {
      window.scrollTo(0, 0);
      this.studyToEdit = sel[0].studyDbId;
      this.page = "edit";
    },
    returnToSearch() {
      this.page = "search";
    },
  },
};
</script>

<style scoped>
</style>